import React, { Component } from 'react'
import Link, { push } from 'gatsby-link'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'

import Navigation from './navigation'
import NavigationMobile from './navigation-mobile'

// import BrandImage from '../../assets/brand/brand-burle-marx-white-200x71.png'
// import BrandImageDark from '../../assets/brand/brand-burle-marx-gray-200x71.png'
import BrandImage from '../../assets/brand/brand-burlemarx-white.svg'
import BrandImageDark from '../../assets/brand/brand-burlemarx-gray.svg'

import Responsive from 'react-responsive'

const Mobile = props => <Responsive {...props} maxWidth={767} />
const Desktop = props => <Responsive {...props} minWidth={992} />

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 8.5vw;
  z-index: 10;
  point-events: none;
`
const Brand = styled.img`
  margin: auto;
  margin-left: 3vw;
  top: 1vw;
  width: 15.625vw;
`

const BrandMobile = styled.img`
  margin: auto;
  margin-top: 0.55vh;
  margin-left: 5vw;
  top: 1vw;
  width: 40vw;
`
const WrapperMobile = Wrapper.extend`
  height: 20vh;
  background-color: red;
`
class Header extends Component {
  constructor() {
    super()
    this.state = { window: {} }
  }

  componentDidMount() {
    if (window) {
      this.setState({ location: window.location })
    }
  }

  _isAtHome(location) {
    const pathname = location.pathname
    return (
      pathname.indexOf('/projetos') === -1 //&&
      // pathname.indexOf('/contato') === -1 //&&
      // pathname.indexOf('/escritorio') === -1 &&
      // pathname.indexOf('/memoria') === -1
    )
  }

  render() {
    const { location } = this.state
    let tone = 'dark'
    if (location && this._isAtHome(location)) {
      tone = 'light'
    }
    return (
      <Wrapper>
        <Desktop>
          <Brand
            src={tone === 'dark' ? BrandImageDark : BrandImage}
            onClick={() => push(`/${window.location.search}`)}
          />
          <Navigation tone={tone} />
        </Desktop>
        <Mobile>
          <BrandMobile
            src={BrandImage}
            onClick={() => push(`/${window.location.search}`)}
          />
          <NavigationMobile tone={tone} />
        </Mobile>
      </Wrapper>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js